/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

require('components/common/table-data/table-data');
const { inputBox: inputBoxEvent, dropMenu: dropMenuEvent } = require('components/config/event.json');
const store = require('appVuex/store');
const { setBreadCrumb } = require('src/common/vuex/action/common');
const tip = require('components/base/pop/tip');
const pop = require('components/base/pop/pop');

const ajaxHttp = require('appUtil/ajaxHttp');
const { apiPath } = require('appService/api');

const calendar = require('components/common/data-calendar/data-calendar');
const template = require('../recycled/recycled-common.tpl');
require("./recycled.scss");

var recycledMixin = {
	template,
	data() {
		return {
			url: apiPath.recycled.recycledList,//获取列表
			clearUrl: apiPath.recycled.clearList, //清空与永久删除
			restoreUrl: apiPath.recycled.restore,//还原

			pageBelong:"",
			deleteList:[],
			typeList:{"1":"资讯","2":"活动","3":"话题"},
			trItems:[],
			modelList:{
				"post":'postId',
				"topics":"topicId",
				'topicsContent':'infoId',
				'comment':'commentId',
				'spotMark':'postId'
			},
			pageItems:{},
			operateItems:[],
			pageInitCt: 1,
			searchName:"",
			searchVal: "",
			timeType:"",
			timeVal:0,
			tagObj:{}, //当前操作的对象
			calendar:{
                show: false,
                x:0,
                y:0,
                picker:"",
                type:"date",
                value:"",
                sep:"-",
                range: false,
                end:'',
                begin:'',
                items:{
                    startTime:{
                        type:"date",
                        value:"",
                        end:new Date().getFullYear()+'-'+(1+new Date().getMonth())+'-'+new Date().getDate(),
               					begin:'',
                        sep:"-"
                    },
                    endTime:{
                        type:"date",
                        value:"",
                        end:new Date().getFullYear()+'-'+(1+new Date().getMonth())+'-'+new Date().getDate(),
                				begin:'',
                        sep:"-"
                    }
                }
            }
		}
	},
methods: {
		timeSet(i){
			this.timeVal = i;

			let startT  = "";
			let endT = "";
			if(i!==0){
				startT = this.formatDay(i);
				endT = this.formatDay(0);

			}
			this.calendar.items.startTime.value = startT;
			this.calendar.items.endTime.value = endT;
			this.searchData();
		},
		tabChange(i){
			this.modelType = i;
			this.searchData();
		},
		searchData(){
			if(this.searchName.indexOf('Id')!=-1 && this.searchVal!="" && !(/^[0-9]+.?[0-9]*$/).test(this.searchVal)){
					tip("搜索的ID值须为数字");
					return;
			}


			let args = {
				'timeType':this.timeType,
				'startTime': this.calendar.items["startTime"].value ? this.calendar.items["startTime"].value : this.beginTime,
				'endTime': this.calendar.items["endTime"].value ? this.calendar.items["endTime"].value: this.endTime,
				'searchName': this.searchName,
				'searchValue': this.searchVal,
				'model':this.model
				
			}
			if(this.model==='topics'){
					args = Object.assign({},args,{'modelType':this.modelType});
			}
			this.$refs.tableData.query(args).fetch();
		},
		formatTime: function (time) {
			let dTime = new Date(time),
				dMinutes = dTime.getMinutes();
			dMinutes = dMinutes < 10 ? "0" + dMinutes : dMinutes;
			return `${dTime.getFullYear()}-${dTime.getMonth() + 1}-${dTime.getDate()}  ${dTime.getHours()}:${dMinutes}`;
		},
		//天数日期转换
		formatDay(t,ac='-'){
			let t1 = new Date(new Date().getTime() - t*24*60*60*1000);
			return `${t1.getFullYear()}${ac}${(1+t1.getMonth())}${ac}${t1.getDate()}`;
		},
		
		getQueryString(name) {
			if(typeof window.location.hash.split("?")[1] === 'undefined'){
				return '';
			}
			let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
			let r = window.location.hash.split("?")[1].match(reg);
			if (r != null) return unescape(r[2]); return null;
		},
		showClearPop() {
			this.$refs.popsclear.show();
		},
		showDelPop(id,idx) {
			this.tagObj = Object.assign({},{'id':id, 'index':idx});
			this.$refs.popsdelete.show();
			console.log(JSON.stringify(this.tagObj));
		},
		restoreTopic(id,idx,topic) {
			let args = {
				'id':id,
				'model':this.model,
				'isDeleted':0
			}

			ajaxHttp(this.restoreUrl, {
			    type: "post",
			    data: args
			}).then((res)=> {
		      tip(res.error || '还原成功');
					this.$refs.tableData.trItems.splice(idx,1);
					this.$refs.tableData.resultData.total -= 1

		      if(typeof topic != 'undefined' && topic>1){
		      	setTimeout(() => {
		      		this.$router.go({name:topic==2? 'infotopic-edit':'activitytopic-edit', params:{id:id}})
		      	},1000)
		      }

		  }).catch((res)=> {
				  tip(res.message);
			})
		},
		clearSure(){

			let idArr = this.$refs.tableData.trItems.map((item,idx) => {
				console.log(item);
				return item[this.modelList[this.model]]
			});
			console.log(idArr.join(","));
			if(idArr==""){
				tip('没有数据');
				this.$refs.popsclear.hide();
				return;
			}
			let args = {
				'model':this.model,
				'modelId':idArr.join(",")
			};
			ajaxHttp(this.clearUrl, {
			    type: "post",
			    data: args
			}).then((res)=> {
		      tip("清空成功");
		      this.$refs.popsclear.hide();
		      this.searchData();
		  }).catch((res)=> {
				  tip(res.message);
			})
		},
		deleteSure(){
			let args = {
				'model':this.model,
				'modelId':this.tagObj.id
			};
			ajaxHttp(this.clearUrl, {
			    type: "post",
			    data: args
			}).then((res)=> {
		      tip(res.error || "删除成功");
					this.$refs.tableData.trItems.splice(this.tagObj.index,1);
					this.$refs.tableData.resultData.total -= 1
		      this.$refs.popsdelete.hide();
		  }).catch((res)=> {
				  tip(res.message);
			})
		},
		
		cancel(){
			this.$refs.popsclear.hide();
			this.$refs.popsdelete.hide();
			this.tagObj = {};
			console.log(JSON.stringify(this.tagObj));
		},
		open(e,type) {
            // 设置类型
            this.calendar.picker=type
            this.calendar.type=this.calendar.items[type].type
            this.calendar.value=this.calendar.items[type].value
            
            // 可不用写
            this.calendar.sep=this.calendar.items[type].sep

            this.calendar.show=true
            this.calendar.x=e.target.offsetLeft
            this.calendar.y=e.target.offsetTop+e.target.offsetHeight+8;
            if(type==="startTime"){
            	this.calendar.end=this.calendar.items.endTime.value || this.calendar.items.endTime.end;;
            	this.calendar.begin="";
            }else{
            	this.calendar.begin=this.calendar.items.startTime.value;
            	this.calendar.end=this.calendar.items.endTime.end;
            }

            this.$refs.dropmenu.fold(); //收起下拉框

        }
	},
	filters:{
        limitStr: function(str, leng) {
            let len = (typeof leng =='undefined')? 32 : leng;
                 if(str.length*2 <= len) {
                  return str;
                 }
             let strlen = 0, s = "";
             for(let i = 0;i < str.length; i++) {
              s = s + str.charAt(i);
              if (str.charCodeAt(i) > 255) {
               strlen = strlen + 2;
               if(strlen >= len){
                return s.substring(0,s.length-1) + "...";
               }
              } else {
               strlen = strlen + 1;
               if(strlen >= len){
                return s.substring(0,s.length-2) + "...";
               }
              }
             }
             return s;
            }
    },
	watch:{
		'calendar.value': function (value) {
            this.calendar.items[this.calendar.picker].value=value;
        }
	},
	components:{
		calendar,
		pop
	},
	events:{
		
		[dropMenuEvent.menu.change](selecObj){
			console.log(selecObj);
			this.calendar.show = false;
			let queryName = selecObj.queryName;
			console.log(this.searchVal);
			if(queryName === 'time'){
				this.timeType = selecObj.value;
				return;
			}
			
			this.searchName = selecObj.value;
			this.placeItem = selecObj.text;
		},
		[inputBoxEvent.change](obj){
				let inputName = obj.queryName;
				if(inputName === 'searchInput'){
					this.searchVal = obj.value
				}
		}
	}
}

module.exports = recycledMixin;



// WEBPACK FOOTER //
// ./src/appBackend/components/page/recycled/recycled/recycledMixin.js